import { useState, useEffect } from "react";

const useFontSize = () => {
  const [scale, setScale] = useState(1);

  // A função de remoção de classes está correta e pode ser mantida assim
  function removerClassesComPrefixo(elemento: HTMLElement, prefixo: string) {
    const classesParaRemover = Array.from(elemento.classList).filter(classe => classe.startsWith(prefixo));
    classesParaRemover.forEach(classe => elemento.classList.remove(classe));
  }

  // Aplica o tamanho da fonte no DOM - só no cliente
  useEffect(() => {
    document.querySelectorAll<HTMLElement>(
      "p, h1, h2, h3, h4, h5, h6, span, div, a, button"
    ).forEach((elemento) => {
      // Salva o tamanho original só se ainda não foi salvo
      if (!elemento.dataset.originalFontSize) {
        const estiloComputado = window.getComputedStyle(elemento);
        const tamanhoOriginal = parseFloat(estiloComputado.fontSize);
        elemento.dataset.originalFontSize = tamanhoOriginal.toString();
      }

      const tamanhoBase = parseInt(elemento.dataset.originalFontSize || "16");
      const novoTamanho = Math.round(tamanhoBase * scale);

      // 1. Remove classes existentes com o prefixo.
      // 2. Adiciona a nova classe com o tamanho da fonte.
      // Essa ordem garante que a classe antiga é sempre removida antes da nova ser adicionada.
      removerClassesComPrefixo(elemento, 'font-scale-');
      elemento.classList.add(`font-scale-${novoTamanho}`);
    });
  }, [scale]);

  const aumentarFonte = () => {
    setScale(prev => Math.min(prev + 0.1, 2));
  };

  const diminuirFonte = () => {
    setScale(prev => Math.max(prev - 0.1, 0.5));
  };

  return { scale, aumentarFonte, diminuirFonte };
};

export default useFontSize;